import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Backdrop(theme) {
  const varLow = alpha(theme.palette.grey[900], 0.48);
  const varHigh = alpha(theme.palette.grey[900], 1);

  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          'backdropFilter': `blur(${6}px)`,
          'WebkitBackdropFilter': `blur(${6}px)`, // Fix on Mobile
          'backgroundColor':
            theme.palette.mode === 'light'
              ? alpha('#F6F5F5', 0.7)
              : alpha(theme.palette.grey[800], 0.7),
          '&.MuiBackdrop-invisible': {
            background: 'transparent',
          },
          'zIndex': 3000,
        },
      },
    },
  };
}
